'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'binary';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e33b';
var svgPathData = ['', 'M320 8c0-2.5-1.2-4.9-3.2-6.4s-4.7-2-7.1-1.2l-80 24c-4.2 1.3-6.6 5.7-5.4 10s5.7 6.6 10 5.4l69.7-20.9 0 189.2-72 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l144 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-56 0 0-200zM96 296c0-2.5-1.2-4.9-3.2-6.4s-4.7-2-7.1-1.2l-80 24c-4.2 1.3-6.6 5.7-5.4 10s5.7 6.6 10 5.4L80 306.8 80 496 8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l144 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-56 0 0-200zm112 56l0 96c0 35.3 28.7 64 64 64l48 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64l-48 0c-35.3 0-64 28.7-64 64zm64-48l48 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM64 0C28.7 0 0 28.7 0 64l0 96c0 35.3 28.7 64 64 64l48 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64L64 0zM16 64c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;